import React from 'react';
import { useSelector } from 'react-redux';
import { search } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useBillingAppendixSetups } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import SearchInput from '../SearchInput.js';
const BillingAppendixSetupSearch = (props) => {
    const lang = useSelector((s) => {
        return s.lang;
    });
    const _billingAppendixSetups = useBillingAppendixSetups();
    const billingAppendixSetups = h.hasData(_billingAppendixSetups)
        ? _billingAppendixSetups.data.filter((billingAppendixSetup) => !billingAppendixSetup.archived)
        : [];
    return (React.createElement("div", null,
        React.createElement(SearchInput, { loading: props.loading, placeholder: lang.billingAppendixSetups.selectBillingAppendixSetup, searchAll: (q) => {
                const res = search(billingAppendixSetups, (ba) => ba.name, q, {
                    returnMeta: false,
                });
                return res.map((ba) => {
                    return {
                        key: ba.billingAppendixSetupId,
                        heading: ba.name,
                        returnData: ba,
                    };
                });
            }, searchDelay: 0, forceOpen: true, static: billingAppendixSetups.find((ba) => ba.billingAppendixSetupId === props.selected)?.name, onRemoveStatic: () => {
                props.onSelect(null);
            }, onSelect: (val) => {
                props.onSelect(val.billingAppendixSetupId);
            } })));
};
export default BillingAppendixSetupSearch;
//# sourceMappingURL=BillingAppendixSetupSearch.js.map